import { useContext } from 'react';
import { ElementPropsContext } from './ElementPropsProvider.js';

const useElementProps = component => {
  const elementProps = useContext(ElementPropsContext);
  return elementProps === null || elementProps === void 0 ? void 0 : elementProps[component];
};

export { useElementProps };
//# sourceMappingURL=useElementProps.js.map
